import content from './content'

export default (state={content}) => state



// WEBPACK FOOTER //
// ./src/Rist/reducer.js